import { getRoles } from '../helpers/roleService';
import { checkError, receiveErrorAlert, closeAlert } from './commonsActions';

/*
 * action types
 */

export const FETCH_ROLES_BEGIN   = 'FETCH_ROLES_BEGIN';
export const FETCH_ROLES_SUCCESS = 'FETCH_ROLES_SUCCESS';

/*
 * action creators
 */

export const fetchRolesBegin = () => ({
	type: FETCH_ROLES_BEGIN
});

export const fetchRolesSuccess = roles => ({
	type: FETCH_ROLES_SUCCESS,
	payload: {
		roles: roles.data,
		// numberOfElements : users.numberOfElements,
		// totalElements: users.totalElements,
		// totalPages: users.totalPages
	}
});

export const fetchRoles = query => dispatch => {
	dispatch(fetchRolesBegin());
	return getRoles(query).then(res => {
		dispatch(fetchRolesSuccess(res));
		return res
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};



// WEBPACK FOOTER //
// ./src/actions/rolesActions.js